module.exports = __webpack_public_path__ + "static/media/product-3-side.2cefbff1.jpg";